// Copy-number control for snippets/gf-contact-links.liquid.
// A custom element, so it connects and disconnects with the Shopify editor's section load and unload.
class GfContactLinks extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-gf-copy]');
    this.status = this.querySelector('[data-gf-status]');
    this.onClick = () => this.copy();
    this.button?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  async copy() {
    if (!this.button || !this.status) return;
    try {
      await navigator.clipboard.writeText(this.button.dataset.gfCopy ?? '');
      this.status.textContent = this.button.dataset.copied ?? '';
    } catch {
      // No success message on failure: select the number so the customer can copy it by hand.
      this.status.textContent = this.button.dataset.failed ?? '';
      const number = this.querySelector('[data-gf-number]');
      const selection = window.getSelection();
      if (!number || !selection) return;
      const range = document.createRange();
      range.selectNodeContents(number);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
}

if (!customElements.get('gf-contact-links')) {
  customElements.define('gf-contact-links', GfContactLinks);
}
